var _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D22F27",
    d: "M13.8451,27.9329c0,0-2.047-1.4682-0.6019-3.1236c0,0-2.2788-2.0129-0.4281-3.9039 c0,0-1.2382-4.0732,2.1382-4.309c0,0-0.3899-4.0721,4.079-3.5985c0,0,2.5018-1.8015,4.3561,0.2489c0,0,2.5324-1.6079,3.8427,0.4026"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D22F27",
    d: "M58.1549,27.9329c0,0,2.047-1.4682,0.6019-3.1236c0,0,2.2788-2.0129,0.4281-3.9039 c0,0,1.2382-4.0732-2.1382-4.309c0,0,0.3899-4.0721-4.079-3.5985c0,0-2.5018-1.8015-4.3561,0.2489c0,0-2.5324-1.6079-3.8427,0.4026"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 23,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D22F27",
    d: "M49.8069,46.5463c0,0-1.58,8.43-13.81,8.76c-12.18-0.44-13.81-8.76-13.81-8.76 c-0.46-1.73-1.2401-5.76,2.28-3.81c2.7,1.5,5.38,4.37,11.53,4.55c6.16-0.18,8.83-3.05,11.53-4.55 C51.0469,40.7863,50.2769,44.8163,49.8069,46.5463z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M35.9981,52.7344c-6.0618,0-9.9298-3.3099-10.9113-4.9147s0.5505-1.1552,0.866-1.003 c2.3137,1.1164,4.0412,2.6979,10.0453,2.9036 M35.9981,52.7344c6.0618,0,9.9298-3.3099,10.9113-4.9147s-0.5505-1.1552-0.866-1.003 c-2.3138,1.1164-4.0412,2.6979-10.0453,2.9036"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "skin-shadow"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M23.4432,21.1746c2.8989-1.5543,6.1935-1.6129,8.6558,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M39.901,21.1746c2.8989-1.5543,6.1935-1.6129,8.6558,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M49.8078,46.5463c0,0-1.58,8.43-13.81,8.76c-12.18-0.44-13.81-8.76-13.81-8.76c-0.46-1.73-1.2401-5.76,2.28-3.81 c2.7,1.5,5.38,4.37,11.53,4.55c6.16-0.18,8.83-3.05,11.53-4.55C51.0478,40.7863,50.2778,44.8163,49.8078,46.5463z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M13.8451,27.9329c0,0-2.047-1.4682-0.6019-3.1236c0,0-2.2788-2.0129-0.4281-3.9039c0,0-1.2382-4.0732,2.1382-4.309 c0,0-0.3899-4.0721,4.079-3.5985c0,0,2.5018-1.8015,4.3561,0.2489c0,0,2.5324-1.6079,3.8427,0.4026"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 23,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M58.1549,27.9329c0,0,2.047-1.4682,0.6019-3.1236c0,0,2.2788-2.0129,0.4281-3.9039c0,0,1.2382-4.0732-2.1382-4.309 c0,0,0.3899-4.0721-4.079-3.5985c0,0-2.5018-1.8015-4.3561,0.2489c0,0-2.5324-1.6079-3.8427,0.4026"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.7711,
    cy: 30.818,
    rx: 3.5,
    ry: 6.3045,
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.2289,
    cy: 30.8216,
    rx: 3.5,
    ry: 6.3045,
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 38.9779,
    r: 2.7351
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "color-foreground"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.7711,
    cy: 30.818,
    rx: 3.5,
    ry: 6.3045,
    fill: "none",
    stroke: "#92D3F5",
    strokeMiterlimit: 10,
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.2289,
    cy: 30.8216,
    rx: 3.5,
    ry: 6.3045,
    fill: "none",
    stroke: "#92D3F5",
    strokeMiterlimit: 10,
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2676,30.816c0,3.04-1.32,5.31-2.5,5.31s-2.5-2.27-2.5-5.31c0-3.03,1.32-5.3,2.5-5.3S30.2676,27.7861,30.2676,30.816z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7276,30.8261c0,3.03-1.32,5.3-2.5,5.3s-2.5-2.27-2.5-5.3c0-3.04,1.32-5.31,2.5-5.31S46.7276,27.7861,46.7276,30.8261z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.0563,
    cy: 38.9779,
    r: 2.7351,
    fill: "#D22F27"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClown);
export default __webpack_public_path__ + "static/media/clown.2e393b888722a83372c990b86860b191.svg";
export { ForwardRef as ReactComponent };